import { FC, PropsWithChildren, useEffect } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { userInfo } from '../redux/nurseshift';
import { logout } from '../redux/login';
import { setTokenInCookies } from '../utils/cookie';
import RestrictedRoutesForShiftManager from '../services/shiftManager';

const SUPERVISOR = 'supervisor';

type State = {
	nurseshift: {
		info: {
			suspended: boolean;
			activated: boolean;
			status: string;
		};
	};
	login: {
		loggedin: boolean;
		token?: string;
	};
	user: {
		is_beat_admin: boolean;
	};
};

export const RequireAuthGuard: FC<PropsWithChildren<any>> = (props) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const authenticated = useSelector((state: State) => state.login.loggedin);
	const info = useSelector((state: State) => state.nurseshift.info);
	const user = useSelector((state: State) => state.user);
	const userToken = useSelector((state: State) => state.login.token);

	useEffect(() => {
		dispatch(userInfo());

		if (info.suspended) {
			dispatch(logout());
		}

		if (!info.activated && info.status === 'inactive') {
			dispatch(logout());
		}

		if (userToken) {
			setTokenInCookies(userToken);
		}
	}, []);

	if (!authenticated) {
		return (
			<Redirect
				to={{
					pathname: '/',
					search: `?redirectTo=${location.pathname}${location.search ?? ''}`
				}}
			/>
		);
	}

	const [, path, search] = location.search.split('?');
	const params = new URLSearchParams(path);
	if (params.has('redirectTo')) {
		const queryString = search ? `?${search}` : '';
		const newURL = `${params.get('redirectTo')}${queryString}`;
		return <Redirect to={newURL} />;
	}

	// Loyalty rewards page allowed for all roles
	if (location.pathname === '/loyalty-rewards') {
		return props.children;
	}

	//Do not allow to access other role(admin,supervisor,nurse) url if you are not logged in through that role.
	if (localStorage.role === SUPERVISOR && !location.pathname.includes('/supervisor')) {
		return <Redirect to="/supervisor/dashboard" />;
	}

	if (
		localStorage.role === SUPERVISOR &&
		localStorage.shift_manager === 'true' &&
		RestrictedRoutesForShiftManager.includes(location.pathname)
	) {
		return <Redirect to="/supervisor/dashboard" />;
	}

	if (
		localStorage.role === 'admin' &&
		!location.pathname.includes('/admin') &&
		!location.pathname.includes('/supervisor/supervisorshiftdetails')
	) {
		return <Redirect to="/admin" />;
	}

	if (localStorage.role === 'nurse' && !location.pathname.includes('/nurse')) {
		return <Redirect to="/nurse/shifts/accepted" />;
	}

	if (window.location.href.includes('?email=') && window.location.href.includes('&password=')) {
		dispatch(logout());
		return null;
	}

	//Avoid unauthorized users to access the beat admin view
	if (localStorage.role === 'admin' && !user.is_beat_admin && location.pathname.includes('admin/beat')) {
		return <Redirect to="/admin" />;
	}

	return props.children;
};
